import { useForm } from '@refinedev/antd';
import { Tabs, Button } from 'antd';

import { CrudFilters } from '@refinedev/core/dist/interfaces';
import { useSchemaDB } from 'hooks/useSchemaDB';
import { TabGeneral } from 'components';
import { FormMode } from 'interfaces/interfaces';

type CreateSlideInfografiasProps = {
    filterList?: CrudFilters
}

const CreateSlideInfografias = ({ filterList }: CreateSlideInfografiasProps) => {
  const { form, formProps, saveButtonProps, queryResult, redirect } = useForm( {
    resource: 'slideInfografia',
    action: 'create',
    redirect : false
  });
  const {schemaDBState,  getTable, getCreateField  } = useSchemaDB({nameTable: 'slideInfografia'})
  const table = getTable('slideInfografia');
  const fieldList = getCreateField(table?table?.length>0?table[0]:null:null);

  const extraContent = (
    <div>
        <Button onClick={saveButtonProps.onClick}>Guardar</Button>
    </div>
  );

  return (
    <Tabs
        tabBarExtraContent={extraContent}
        items={[
            {
                key: '1',
                label: 'General',
                children: (
                    <TabGeneral
                        fieldList={fieldList.filter((field) => field.tabNumber ===1)}
                        formMode={FormMode.create}
                        resourceName = {'slideInfografia'}
                        filterList={filterList}
                        form = {form}
                    />
                )
            },
            {
                key: '2',
                label: 'Títulos',
                children: (
                    <TabGeneral
                        fieldList={fieldList.filter((field) => field.tabNumber === 2)}
                        formMode={FormMode.create}
                        resourceName = {'slideInfografia'}
                        filterList={filterList}
                        form = {form}
                    />
                )
            },
            {
                key: '3',
                label: 'Textos',
                children: (
                    <TabGeneral
                        fieldList={fieldList.filter((field) => field.tabNumber === 3)}
                        formMode={FormMode.create}
                        resourceName = {'slideInfografia'}
                        filterList={filterList}
                        form = {form}
                    />
                )
            },
            {
                key: '4',
                label: 'Contenido Extra',
                children: (
                    <TabGeneral
                        fieldList={fieldList.filter((field) => field.tabNumber === 4)}
                        formMode={FormMode.create}
                        resourceName = {'slideInfografia'}
                        filterList={filterList}
                        form = {form}
                    />
                )
            }
        ]}
    />
  )
}

export default CreateSlideInfografias;